import styles from './image.module.scss';

type ClassName = 'default' | 'compact' | 'offset-to-left';

export default class Image {
	public element:HTMLImageElement = document.createElement('img');
	
	constructor(src:string, className:ClassName='default') {
		this.element.src = src;
		this.element.dataset.nameSpace = 'dentolo';
		this.element.className = styles[className];
		this.element.alt = "";
	}
}